export const iconFontAwesomeMoneyAustralSign = (
	<i className="fa-solid fa-austral-sign"></i>
);
